import React, { useState } from 'react';
import { Box, Paper, Tab } from '@mui/material';
import ConsoleTabs from '../common/ConsoleTabs';
import L2OpenConfigAdmin from './L2OpenConfigAdmin';
import LakeCaseOwnersAdmin from './LakeCaseOwnersAdmin';
import TopCustomerAccountsAdmin from './TopCustomerAccountsAdmin';
import SalesforceConfigAdmin from './SalesforceConfigAdmin';
import BriefingPerformanceSyncAdmin from './BriefingPerformanceSyncAdmin';

const SECTIONS = [
  { key: 'l2Open', label: 'L2 Open definition', Component: L2OpenConfigAdmin },
  { key: 'owners', label: 'L1 Case Owners', Component: LakeCaseOwnersAdmin },
  { key: 'accounts', label: 'Top Customer Accounts', Component: TopCustomerAccountsAdmin },
  { key: 'salesforce', label: 'Salesforce configuration', Component: SalesforceConfigAdmin },
  { key: 'perfSync', label: 'Client Performance sync', Component: BriefingPerformanceSyncAdmin }
];

/**
 * Admin → Ops Center → Vital Signs Config: everything that configures the Vital Signs page, one sub-tab each.
 * The sub-tabs are the existing admin screens, unchanged, plus the L2 Open definition and
 * briefing Client Performance Datadog sync.
 */
const VitalSignsConfigAdmin = () => {
  const [tabValue, setTabValue] = useState(0);
  const { Component } = SECTIONS[tabValue];

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <ConsoleTabs
          value={tabValue}
          onChange={(event, newValue) => setTabValue(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {SECTIONS.map(({ key, label }) => <Tab key={key} label={label} />)}
        </ConsoleTabs>
      </Paper>
      <Component />
    </Box>
  );
};

export default VitalSignsConfigAdmin;
